import React from "react";
import Container from "react-bootstrap/Container";
import Accordion from "react-bootstrap/Accordion";
import Badge from "react-bootstrap/Badge";
import Alert from "react-bootstrap/Alert";

import "bootstrap/dist/css/bootstrap.min.css";

const Update052 = () => {
  return (
    <Container className="mt-4 mb-5">
      <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
        <h2 className="m-0">Оновлення 0.5.2</h2>
        <Badge bg="success">Реалізовано</Badge>
      </div>
      <p className="text-muted">
        У рапортах водія і партнера ZUS та інші видатки більше не показуються двічі. Сума виплати не змінювалась —
        виправляється лише список у рапорті.
      </p>

      <Alert variant="info">
        <b>Коротко:</b> у збереженому рапорті одні й ті самі суми лежали під двома назвами (наприклад ZUS і ще раз ZUS,
        «Інше» і ще раз той самий список). Екран виводив обидва рядки. Тепер кожна стаття — один рядок. Старі рапорти
        перезберігати не потрібно.
      </Alert>

      <Accordion defaultActiveKey="0" alwaysOpen className="mb-4">
        <Accordion.Item eventKey="0">
          <Accordion.Header>1. Що було не так</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                Розрахунок виплати брав ZUS, оренду, «інше» та повернення <b>один раз</b>. Підсумок був правильний.
              </li>
              <li>
                У списку додаткових коштів ті самі поля показувались повторно: ZUS другим рядком і «інші видатки»
                ще раз окремим блоком.
              </li>
              <li>Так було і в кабінеті водія, і в перегляді рапорту в адмінці.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>2. Як виглядає рапорт тепер</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                У блоці додаткових коштів кожна стаття один раз: повернення VAT, податки і ZUS, партнерка, бухгалтер,
                оренда авто, інше, повернення коштів.
              </li>
              <li>Розшифровка «іншого» лишається під рядком «Інше», а не окремою другою сумою.</li>
              <li>Зарплата як і раніше окремо під виплатою на рахунок.</li>
              <li>Вже опубліковані рапорти відкриваються правильно без повторного збереження.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>3. Що перевірити</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>Відкрийте опублікований рапорт у кабінеті водія — ZUS і «інше» мають бути по одному рядку.</li>
              <li>Той самий рапорт в адмінці (перегляд рапорту) — той самий список, без дублів.</li>
              <li>Сума «Виплата на рахунок» має лишитись тією самою, що й до оновлення.</li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default Update052;
